import { Account, getFranchise } from "../models/Account";

interface GAEvent {
    type: string, 
    params: any
}

interface GTAG {
    gtag(type:string, eventName:string, eventParameters:any):void;
}

interface AccountEventInfo {
    account_name: string
    account_state: string
    account_franchise: string
}

interface AccountViewEvent {
    type: "account_view"
    params: AccountEventInfo
}

interface LoginEvent {
    type: "user_login"
    params: {}
}

interface CEPSeachEvent {
    type: "cep_search"
    params: {query: string}
}

interface ChangePeriodhEvent {
    type: "change_period"
    params: {period: string}
}

interface AccountChannelEvent {
    type: "account_channel_report"
    params: AccountEventInfo & {period: string}
}

interface ChannelReportEvent {
    type: "channel_report"
    params: {period: string, date: string}
}



export function logEvent(event: LoginEvent | AccountViewEvent | CEPSeachEvent | ChangePeriodhEvent | ChannelReportEvent | AccountChannelEvent){
    const logger = (window as any) as GTAG;
    if(!logger.gtag)
        return;
    logger.gtag("event", event.type, event.params)
}

export function getAccountEventInfo(account:Account):AccountEventInfo{
    return {account_name: account.name, account_state: account.state, account_franchise: getFranchise(account)}
}